var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUesr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#72383D;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17017 -5816)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 60,
    rx: 4,
    transform: "translate(17017 5816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.04,22.04a9.02,9.02,0,1,0-9.02-9.02A9.018,9.018,0,0,0,22.04,22.04Zm0,4.51C16.019,26.55,4,29.572,4,35.57v4.51H40.08V35.57C40.08,29.572,28.061,26.55,22.04,26.55Z",
    transform: "translate(17024.961 5824.956)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUesr);
export default __webpack_public_path__ + "static/media/icon_uesr.f2d3f7bb1cb35727fd8f54dff1bafd3d.svg";
export { ForwardRef as ReactComponent };